module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.about)),
      expression: "clientProfile && isFilled(clientProfile.about)"
    }]
  }, [_c('b', [_vm._v("О компании:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.about)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.website)),
      expression: "clientProfile && isFilled(clientProfile.website)"
    }]
  }, [_c('b', [_vm._v("Сайт:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.clientProfile.website
    }
  }, [_vm._v(_vm._s(_vm.clientProfile.website))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.contacts)),
      expression: "clientProfile && isFilled(clientProfile.contacts)"
    }]
  }, [_c('b', [_vm._v("Контакты:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.contacts)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.services)),
      expression: "clientProfile && isFilled(clientProfile.services)"
    }]
  }, [_c('b', [_vm._v("Товары и услуги:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.services)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.price)),
      expression: "clientProfile && isFilled(clientProfile.price)"
    }]
  }, [_c('b', [_vm._v("Цены:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.price)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.docs)),
      expression: "clientProfile && isFilled(clientProfile.docs)"
    }]
  }, [_c('b', [_vm._v("Публичные документы:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.docs)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.tags)),
      expression: "clientProfile && isFilled(clientProfile.tags)"
    }]
  }, [_c('b', [_vm._v("Поисковые Теги:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.tags)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.other)),
      expression: "clientProfile && isFilled(clientProfile.other)"
    }]
  }, [_c('b', [_vm._v("Разное:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.other)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ccf5cde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientPreview.vue
// module id = 1002
// module chunks = 1